export const AssetTypeId = 'assettype';
export const AssetSubTypeId = 'assetsubtype';
export const CampaignTypeId = 'campaign';
export const KeywordTypeId = 'keyword';
export const OurCausesTypeId = 'ourcauses';
export const LanguagesTypeId = 'languages';
export const RegionTypeId = 'region';
export const FacetHeadingId = 'facetheading';

export const AssetTypeFilter = 'Asset Type';
export const AssetSubTypeFilter = 'Asset SubType';
export const CampaignTypeFilter = 'Campaign';
export const KeywordTypeFilter = 'Keyword';
export const OurCausesTypeFilter = 'Our Causes';
export const RegionTypeFilter = 'Region';

export const AssetTypeTemplateId = '16684131-10fc-4015-b5b3-be06a8534ab5';
export const AssetSubTypeTemplateId = '33fda690-5dde-40bc-9852-0fd1e68c396d';
export const CampaignTemplateId = '3bb9fe02-4893-4c5f-9754-4b12f019d620';
export const OurCausesTemplateId = '92410d78-4f54-4fa8-99af-6690dcde7655';
export const KeywordsTemplateId = '1a379062-0cb1-4d60-8c74-8b5108c05ebb';
export const LanguageTemplateId = 'f81e8824-bc87-47a6-9948-d61079b0c174';
export const RegionTemplateId = '935307eb-7df8-4b7d-9764-202144a4d869';
